import { FieldValues, FormProvider, useForm } from "react-hook-form"
import ProfileForm from "./ProfileForm"
import { useEffect, useState } from "react"
import agent from "../../app/api/agent"
import { LoadingButton } from "@mui/lab"
import { useNavigate } from "react-router-dom"
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import { useAppSelector } from "../../app/store/configureStore"
import UpdateEmail from "./UpdateEmail"

export default function Profile() {
  const [loading, setLoading] = useState(false)
  const [updateEmail, setUpdateEmail] = useState(false)
 
  const {user} = useAppSelector(state => state.account)
  const [profileInDatabase, setProfileInDatabase] = useState(false)
  const methods = useForm()
  const navigate = useNavigate()

  

  useEffect(() => {
    agent.Account.fetchProfile()
        .then(response => {
          
            if (response) {
                Object.keys(response).forEach(k => response[k] = response[k] === null ? '' : response[k]) // change null to '' to get rid of the warning from controlled to uncontrolled
                methods.reset({...methods.getValues(), ...response})
                setProfileInDatabase(true)
            } // reset the form values based on response. getValues() to get the existing form values. ...response override the values in the form
        })
}, [methods])

  function cancelUpdate() {
      setUpdateEmail(false)
  }

  function submit(data: FieldValues) {
      setLoading(true)
      agent.Account.createProfile(data).then(() => {
        setLoading(false)
        navigate('/catalog')
      }
      
      )

  }
  return (
    <>
      <Typography variant="h3" marginBottom={4}>My Profile</Typography>
      <TableContainer component={Paper} sx={{mb: 2}}>
          <Table aria-label="simple table">
              <TableBody>
                      <TableRow
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                          <TableCell component="th" scope="row">
                              Username: 
                          </TableCell>
                          <TableCell align="left">
                              {user?.username}
                          </TableCell>
                          <TableCell align="left">
                              
                          </TableCell>
                      </TableRow>
                      <TableRow
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                          <TableCell component="th" scope="row">
                              Email: 
                          </TableCell>
                          <TableCell align="left">
                              {user?.email}
                          </TableCell>
                          <TableCell align="left">
                            {updateEmail ? 
                              <UpdateEmail cancelUpdate={cancelUpdate}/> : <Button variant='contained' onClick={() => setUpdateEmail(true)}>Update email</Button>
                              
                            }
                          </TableCell>
                      </TableRow>
              </TableBody>
          </Table>
      </TableContainer>
      <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(submit
            )}>
              <ProfileForm />
              {profileInDatabase ? 
              <LoadingButton loading={loading}  variant="contained" 
                  disabled={!methods.formState.isDirty}
                                  type="submit"
                                  sx={{mt: 3, mb: 4}}>Update</LoadingButton>
                                : 
                                
              <LoadingButton variant="contained" type="submit" 
              sx={{mt: 3, ml: 1, mb: 4}}>Create</LoadingButton>}
              
          </form>
      </FormProvider></>
  )
}